import React from 'react';
import {useDblIntl} from "@/pages/datalab/utils/utils";

export default PortPage;

function PortPage() {
  const { dblFormatMessage: multiFormatMessage} = useDblIntl("multi");
  return (
    <>
      <div className="guide_operation-title">{multiFormatMessage("operational_guide")}</div>
      <div className="guide_operation-flex">
        <div className="flex-left">
          <div className="flex-left-num">1</div>
          <div className="flex-left-text">{multiFormatMessage("operational_one_title")}</div>
        </div>
        <div className="flex-right">
          <div className="flex-right-text">
            {multiFormatMessage("operational_one_content_first")}<br />
            {multiFormatMessage("operational_one_content_second")}
          </div>
        </div>
      </div>
      <div className="guide_operation-flex">
        <div className="flex-left">
          <div className="flex-left-num">2</div>
          <div className="flex-left-text">{multiFormatMessage("operational_two_title")}</div>
        </div>
        <div className="flex-right">
          <div className="flex-right-text">
            {multiFormatMessage("operational_two_content_tip")}
            <br />
            {multiFormatMessage("operational_two_content_first")}
            <br />
            {multiFormatMessage("operational_two_content_second")}
          </div>
        </div>
      </div>
      <div className="guide_operation-flex">
        <div className="flex-left">
          <div className="flex-left-num">3</div>
          <div className="flex-left-text">{multiFormatMessage("operational_three_title")}</div>
        </div>
        <div className="flex-right">
          <div className="flex-right-text">
            {multiFormatMessage("operational_three_content_first")}
            <br />
            {multiFormatMessage("operational_three_content_second")}
          </div>
        </div>
      </div>
    </>
  );
}
